import Base from './Base';
import User from './User';
import { icons } from 'components/Icon/VectorIcon.vue';
import moment from 'moment';

export default class Trigger extends Base {
    constructor(item) {
        super(item);

        if (item.owner) {
            this.owner = new User(item.owner);
        }
    }

    aggregate(key) {
        if (this.statistics && this.statistics.length > 0) {
            return this.statistics.map((stat) => stat[key]).reduce((prev, next) => prev + next);
        }
        return 0;
    }

    percentage(key) {
        let total = this.aggregate('total_count');
        if (total > 0) {
            let percentage;
            if (key === 'short_links_clicks') {
                percentage = (this.aggregateShortLinksClicks / total) * 100;
            } else {
                percentage = (this.aggregate(key) / total) * 100;
            }

            if (percentage >= 100) {
                return percentage.toFixed();
            }

            return percentage.toFixed();
        }

        return 0;
    }

    percentageFailed() {
        let total = this.aggregate('total_count');

        if (total > 0) {
            let failed = total - this.aggregate('success_count');
            let percentage = (failed / total) * 100;

            return percentage.toFixed();
        }

        return 0;
    }

    get aggregateShortLinksClicks() {
        if (this.short_urls && this.short_urls.length > 0) {
            return this.short_urls.map((url) => url.clicks).reduce((prev, next) => prev + next);
        }
        return 0;
    }

    get substringName() {
        const length = 255;
        const substringName = this.name.substring(0, length - 3);

        return this.name.length > length ? substringName : this.name;
    }

    get isNumberableTypeNumbersShortcode() {
        if (!this.number) return false;

        return this.number.numberable_type === 'App\\Numbers\\Shortcode';
    }

    get fullNameNumberable() {
        if (this.number && this.number.numberable_type === 'App\\Users\\User') {
            return (this.number.numberable && this.number.numberable.full_name) || '-';
        }

        if (this.number && this.number.numberable_type === 'App\\Teams\\Team') {
            return (this.number.numberable && this.number.numberable.name) || 'Unnamed Inbox';
        }

        if (this.number && this.number.numberable_type === 'App\\Numbers\\Shortcode') {
            return (this.number.numberable && this.number.numberable.name) || 'Shortcode';
        }

        if (!this.number && this.team) {
            return this.team.name || 'Unnamed Inbox';
        }

        return '';
    }

    get numberId() {
        return this.number && this.number_id;
    }

    get isNumberableSmartInbox() {
        return !this.number && this.team;
    }

    get numberType() {
        return this.number && this.number.numberable_type;
    }

    get isDefaultNumberableAvatar() {
        if (!this.number.numberable.photo_url) {
            return false;
        }

        return this.number.numberable.photo_url.includes(`${window.location.hostname}/images/app/default-avatar.png`);
    }

    get numberablePhotoUrl() {
        return this.number.numberable.photo_url;
    }

    get formattedNumber() {
        if (!this.number) return '';

        return this.number.formatted_number;
    }

    get getSmartInboxDetails() {
        if (!this.team) {
            return '';
        }
        if (this.team.numbers_count > 1) {
            return `${this.team.numbers_count} numbers`;
        }

        return this.team.number ? this.team.number.formatted_number : '';
    }

    get getSmartInboxIcon() {
        const options = {
            classes: 'svg-inline--fa fa-building fa-w-14 fa-2x',
        };

        return (this.team && (this.team.numbers_count > 1))
            ? icons(options)['smart-inbox']
            : icons(options)['shared-inbox-v2'];
    }

    get color() {
        const palette = [
            '#6372A5',
            '#1D95F2',
            '#10D0AD',
            '#E13466',
            '#FFC422',
            '#FF9423',
            '#A233E1',
        ];

        return palette[this.id % palette.length];
    }

    get isAnalytics() {
        return Boolean(this.analytics);
    }

    get usersWithConversion() {
        if (!this.isAnalytics) return 0;

        return this.analytics.users_with_conversion;
    }

    get conversionRate() {
        if (!this.isAnalytics) return 0;
        if (!this.aggregate('success_count')) return 0;

        let result = (this.analytics.users_with_conversion / this.aggregate('success_count')) * 100;

        if (result === 100) {
            return 100;
        }
        return result;
    }

    get conversionValue() {
        if (!this.isAnalytics) return 0;

        return this.analytics.conversion_value;
    }

    get integrationName() {
        if (!this.integration_name) {
            return '';
        }

        return this.integration_name;
    }

    get statusFormatted() {
        if (this.is_active) {
            return 'Active';
        } else return 'Inactive';
    }

    get createdAt() {
        return this.created_at;
    }

    get isRingless() {
        return this.is_rvm;
    }

    get createUpdateTimeFormated() {
        if (this.updated_at) {
            return moment(this.updated_at).format('D MMM, YYYY - h:mm');
        }

        if (this.created_at) {
            return moment(this.created_at).format('D MMM, YYYY - h:mm');
        }

        return moment().format('D MMM, YYYY - h:mm');
    }

    get mediaUrl() {
        if (!this.media_url) return [];

        return this.media_url;
    }

    get statusClass() {
        if (this.is_active) {
            return 'has-background-success';
        } else return 'has-background-warning';
    }

    get isNumberableTypeUsersUser() {
        if (!this.number) {
            return false;
        }

        return this.number.numberable_type === 'App\\Users\\User';
    }

    get isNumberableTypeTeamsTeam() {
        if (!this.number) {
            return false;
        }

        return this.number.numberable_type === 'App\\Teams\\Team';
    }
}
